import { render, staticRenderFns } from "./EntityTypeCreate.vue?vue&type=template&id=f2a7cd36"
import script from "./EntityTypeCreate.vue?vue&type=script&lang=js"
export * from "./EntityTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports